// @ts-nocheck
import appConfig from 'config/appConfig';
import { isConstructorDeclaration } from 'typescript';

const LIMIT_ITEMS = 10;
const RECENT_LIMIT = 9;

export async function getAllProperties(
  // language?: string,
  // city?: number[],
  // zone?: string[],
  // type?: number[],
  // status?: string[],
  // condition?: string[],
  // bedrooms?: number,
  // bathrooms?: number,
  // minprice?: number,
  // maxprice?: number,
  // minarea?: number[],
  // maxarea?: number[],
  // showOffers?: boolean,
  // extras?: string[], // maybe int[]..
  // sortby?: string,
  // page?: number

  {
    language,
    city,
    zone,
    type,
    status,
    condition,
    bedrooms,
    bathrooms,
    minprice,
    maxprice,
    minarea,
    maxarea,
    showOffers,
    extras,
    sortby,
    page,
  }
) {
  try {
    console.log(
      language,
      city,
      zone,
      type,
      status,
      condition,
      bedrooms,
      bathrooms,
      minprice,
      maxprice,
      minarea,
      maxarea,
      showOffers,
      extras,
      sortby,
      page
    );

    console.log('TYPE');
    console.log(type);

    console.log('Limit, page and sortby ');
    console.log(LIMIT_ITEMS, page, sortby);
    const url = `${appConfig.URL}app/data_properties.php?lang=${language}&city=${city}&zone=${zone}&type=${type}&status=${status}&condition=${condition}&minbeds=${bedrooms}&minbaths=${bathrooms}&minprice=${minprice}&maxprice=${maxprice}&minarea=${minarea}&maxarea=${maxarea}&offers=${showOffers}&extras=${extras}&sortby=${sortby}&limit=${LIMIT_ITEMS}&page=${page}`;
    let response = await fetch(url);
    let responseJson = await response.json();

    console.log('DATA CONTROLLER -->');

    // console.log(
    //   language,
    //   city,
    //   zone,
    //   type,
    //   status,
    //   condition,
    //   bedrooms,
    //   bathrooms,
    //   minprice,
    //   maxprice,
    //   minarea,
    //   maxarea,
    //   offers,
    //   extras,
    //   sortby,
    //   page
    // );

    console.log(responseJson);
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getCities(language: string) {
  try {
    const url = `${appConfig.URL}app/data_cities.php?lang=${language}`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getTypes(language: string) {
  try {
    const url = `${appConfig.URL}app/data_types.php?lang=${language}`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getConditions(language: string) {
  try {
    const url = `${appConfig.URL}app/data_conditions.php?lang=${language}`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getExtras(language: string) {
  const url = `${appConfig.URL}app/data_extras.php?lang=${language}`;

  try {
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {}
}

export async function getPropertyById(language, id) {
  try {
    const url = `${appConfig.URL}app/data_property.php?lang=${language}&id=${id}&limit=1`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(error);
  }
}

export async function getGalleryByProperty(language, id) {
  try {
    const url = `${appConfig.URL}app/data_gallery.php?lang=${language}&id=${id}`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getExtrasByProperty(language, id) {
  try {
    const url = `${appConfig.URL}app/data_extras.php?lang=${language}&id=${id}`;
    let response = await fetch(url);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    //console.error(error);
  }
}

export async function getPriceInEUR(hufAmount) {
  try {
    let priceInHUF = hufAmount;
    priceInHUF = priceInHUF.replace(/\./g, '');
    priceInHUF = priceInHUF.replace(/Ft/g, '');
    console.log('Connector price in huf:');
    console.log(priceInHUF);
    const url = `https://api.exchangerate.host/latest?base=HUF&symbols=EUR&amount=${priceInHUF}&places=0`;
    let response = await fetch(url);
    let responseJson = await response.json();
    console.log('RESP PRICE CONNECTOR: ' + responseJson.rates.EUR);
    if (responseJson.success !== true) {
      return 0;
    }
    //return responseJson.rates.EUR;
    const priceInEUR = responseJson.rates.EUR;
    var parts = priceInEUR.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    parts.join(',');
    return '€ ' + parts[0];
  } catch (error) {
    //console.error(error);
  }
}
